<ng-container *ngIf="user">
  <app-toolbar [title]="title" [user]="user" [destination]="destination" [back]="back"></app-toolbar>
</ng-container>
<div class="container">
  <mat-card class="mat-elevation-z10">
    <div style="vertical-align: middle">
      <span class="material-icons && back-nav" routerLink="/login">navigate_before</span>
      <h1>Reset password</h1>
      <p id="descrizioneNewPass">La nuova password dovrà essere lunga almeno 8 caratteri. Per una password sicura si consiglia di utilizzare:</p>
      <li>Un carattere minuscolo</li>
      <li>Un carattere maiuscolo</li>
      <li>Un numero</li>
      <li>Un carattere speciale (<span id="caratteriSpeciali">esempi di simboli ! # $ % & * ( ) + , - . / : ; &#60; = &#62; ? @ [ \ ] ^ _ £</span>)</li>
    </div>

    <mat-card-content fxLayout="column">

      <form class="form" [formGroup]="passwordChangeForm">

        <mat-form-field appearance="outline" style="padding-bottom: 10px">
          <mat-label>Inserisci la tua vecchia password</mat-label>
          <!--<input matInput type="password" formControlName="newPassword">-->
          <input matInput id="oldPassword" [type]="hide ? 'password' : 'text'" formControlName="oldPassword" required>
          <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Nascondi password'" [attr.aria-pressed]="hide">
            <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <mat-error *ngIf="this.passwordChangeForm.get('oldPassword').invalid">{{getErrorMessage()}}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" style="padding-bottom: 10px">
          <mat-label>Inserisci la tua nuova password</mat-label>
          <!--<input matInput type="password" formControlName="newPassword">-->
          <input matInput id="newPassword" [type]="hide ? 'password' : 'text'" formControlName="newPassword" required>
          <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Nascondi password'" [attr.aria-pressed]="hide">
            <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <mat-error *ngIf="this.passwordChangeForm.get('newPassword').invalid">{{getErrorMessage()}}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" style="padding-bottom: 10px">
          <mat-label>Conferma la tua nuova password</mat-label>
          <input matInput [type]="hideConfirm ? 'password' : 'text'" formControlName="confirmNewPassword">
          <button mat-icon-button matSuffix (click)="hideConfirm = !hideConfirm" [attr.aria-label]="'Nascondi password'" [attr.aria-pressed]="hideConfirm">
            <mat-icon>{{hideConfirm ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <mat-error *ngIf="this.passwordChangeForm.get('confirmNewPassword').invalid">{{getErrorMessage()}}</mat-error>
        </mat-form-field>

        <ng-container *ngIf="submitted">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </ng-container>

        <div style="text-align: center">
          <ng-container *ngIf="!show">
            <button mat-raised-button type="submit" color="primary"
                    [disabled]="!passwordChangeForm.valid" (click)="onSubmit(passwordChangeForm.value)">Invia</button>
          </ng-container>
        </div>

      </form>

    </mat-card-content>
  </mat-card>
</div>
